import { NextStepsResponse, NextStepsV2Response, Plan } from "stash/components/subscription/manage/types";

export type DowngradeState = {
	nextSteps: NextStepsResponse | NextStepsV2Response;
	currentPlan: Plan;
	newPlan: Plan;
	iraSourceId?: string;
}

export const SET_DOWNGRADE_STATE = 'SET_DOWNGRADE_STATE';
export const CLEAR_DOWNGRADE_STATE = 'CLEAR_DOWNGRADE_STATE';

export const setDowngradeState = (state: DowngradeState) => ({
	type: SET_DOWNGRADE_STATE,
	payload: state,
});

export const clearDowngradeState = () => ({
	type: CLEAR_DOWNGRADE_STATE,
});
